import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatTableDataSource } from '@angular/material';
import { MeasurementRequestService } from '../../services/measurement-request.service';
import { MeasurementRequest } from '../../models/measurement-request';
import { FormControl } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'app-request-selector',
  templateUrl: './request-selector.component.html',
  styleUrls: ['./request-selector.component.css']
})
export class RequestSelectorComponent implements OnInit {

  public displayedColumns = ['actions','customerCode','account','accountPhone','accountEmail','contact','decisionDate'];
  public dataSource:MatTableDataSource<MeasurementRequest>;
  constructor(public dialogRef: MatDialogRef<RequestSelectorComponent>, private measurementRequestService:MeasurementRequestService ) { 


  }
  public searchControl: FormControl = new FormControl(null);
  ngOnInit() {
    this.getAll();
    this.searchControl.valueChanges.pipe(debounceTime(500)).subscribe((text)=>{
      if(text){
        this.onSearch(text);
      }
    })
  }
  public getAll = () => {
    this.measurementRequestService.GetAll(null,null,1,10)
    .subscribe(res => {
      this.dataSource =  new MatTableDataSource<MeasurementRequest>(res.payload);
    })
  }
  selectedRow:MeasurementRequest;
  onSelect(item:MeasurementRequest){
    this.selectedRow = item;
  }
  onSearch(text:any){
    this.measurementRequestService.Filter(`contains(customerCode, '${text}') or contains(account, '${text}') or contains(contact, '${text}')`,'date','desc',1,10).subscribe(res=>{
      this.dataSource.data = res.payload;
    })
  }
}
